import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/toaster";

// Layout Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import PageTransition from "./components/PageTransition";
import TopLoadingBar from "./components/TopLoadingBar";
import DPDPConsentBoot from "./components/DPDPConsentBoot";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import DeploymentHelper from "./pages/DeploymentHelper";

// Service Pages
import Cybersecurity from "./pages/Services/Cybersecurity";
import SystemIntegration from "./pages/Services/SystemIntegration";
import NetworkServices from "./pages/Services/NetworkServices";
import AIIntelligentSystems from "./pages/Services/AIIntelligentSystems";
import AutomationRPA from "./pages/Services/AutomationRPA";
import DataPlatforms from "./pages/Services/DataPlatforms";
import IoTSmartInfra from "./pages/Services/IoTSmartInfra";
import CloudDevOps from "./pages/Services/CloudDevOps";
import TelecomTowerRF from "./pages/Services/TelecomTowerRF";

function AppContent() {
  const location = useLocation();
  
  return (
    <>
      <TopLoadingBar />
      <Header />
      <main className="pt-20">
        <PageTransition key={location.pathname}>
          <Routes location={location}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/services/cybersecurity" element={<Cybersecurity />} />
            <Route path="/services/system-integration" element={<SystemIntegration />} />
            <Route path="/services/network-services" element={<NetworkServices />} />
            <Route path="/services/ai-intelligent-systems" element={<AIIntelligentSystems />} />
            <Route path="/services/automation-rpa" element={<AutomationRPA />} />
            <Route path="/services/data-platforms" element={<DataPlatforms />} />
            <Route path="/services/iot-smart-infra" element={<IoTSmartInfra />} />
            <Route path="/services/cloud-devops" element={<CloudDevOps />} />
            <Route path="/services/telecom-tower-rf-infrastructure" element={<TelecomTowerRF />} />
            <Route path="/deployment-helper" element={<DeploymentHelper />} />
          </Routes>
        </PageTransition>
      </main>
      <Footer />
      <Toaster />
      <DPDPConsentBoot />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
